import {
    Deposit,
    FieldInterventionEntity,
    Layer,
    LayerControllerGetEntities200ResponseAllOfItemsInner as DataEntityAdditionalProperties,
    MapboxStyle,
    Person,
    Role,
} from '@connect-services/client/sdk/api';

export type BaseEntityPropertiesType = { identifier: string; layerId: string; uuid: string };

export type EntityProperties = BaseEntityPropertiesType &
    (DataEntityAdditionalProperties | Record<string, string | number | Record<string, unknown>>);

export type FieldInterventionEntityExtended = FieldInterventionEntity & {
    dataAttributes: Record<'businessIdentifier' | string, unknown>;
};
type FieldInterventionEntityWithStyle = FieldInterventionEntityExtended & {
    style: MapboxStyle[];
};

export type PanelActions =
    | ActionsEnum
    | CreateProjectEnum
    | DataEnum
    | EntityEnum
    | FieldInterventionEnum
    | FilterEnum
    | LayerEnum
    | ProfileEnum
    | ProjectSettingsEnum
    | RoleEnum
    | UserEnum;

export type PanelData =
    | DataEntityAdditionalProperties
    | Deposit
    | EntityProperties
    | FieldInterventionEntityExtended[]
    | FieldInterventionEntityWithStyle
    | Layer
    | Person
    | Role;

export enum ActionsEnum {
    AI = 'sparkles',
    FIELD_INTERVENTION = 'clipboard-list-check',
    LAYER = 'layer-group',
    NETWORK_PATH = 'network-path',
    SETTINGS = 'gear',
    STATISTICS = 'chart-pie',
    SYNOPTIC = 'diagram-project',
}

export enum FieldInterventionEnum {
    FIELD_INTERVENTION_CREATE = 'field-intervention-create',
    FIELD_INTERVENTION_ENTITY_PLANNING = 'field-intervention-entity-planning',
    FIELD_INTERVENTION_ENTITY_DETAIL = 'field-intervention-entity-details',
    FIELD_INTERVENTION_DASHBOARD = 'field-intervention-dashboard',
    FIELD_INTERVENTION_LAYER_DETAIL = 'field-intervention-layer-detail',
}

export enum CreateProjectEnum {
    ADD_LAYER = 'add-layer',
}

export enum DataEnum {
    DATA_DETAIL = 'data-detail',
    DATA_EDITION = 'data-edition',
}

export enum EntityEnum {
    ENTITY_DETAIL = 'entity-detail',
    ENTITIES_LIST = 'entities-list',
    ENTITIES_LIST_UPDATE = 'entities-list_update',
    TABLE_ENTITY_DETAIL = 'table-entity-detail',
}

export enum FilterEnum {
    LAYOUT_FILTER_CREATION_EDITION = 'layout-filter-creation-edition',
}

export enum LayerEnum {
    DEPOSIT_LAYER_DETAIL = 'deposit-layer-detail',
}

export enum ProfileEnum {
    PROFILE_EDITION = 'profile-edition',
}

export enum ProjectSettingsEnum {
    ADD_LAYER = 'add-layer',
    ADD_USER = 'add-user',
    LAYER_DETAIL = 'layer-detail',
    LAYER_EDITION = 'layer-edition',
    PROJECT_EDITION = 'project-edition',
}

export enum RoleEnum {
    ROLE_CREATE = 'role-create',
    ROLE_DETAIL = 'role-detail',
    ROLE_EDITION = 'role-edition',
}

export enum UserEnum {
    USER_DETAIL = 'user-detail',
    USER_EDITION = 'user-edition',
    USER_CREATE = 'user-create',
}
